import React from 'react';
import { CardMedia, Stack, Typography } from '@mui/material';
import FocusInspectionButtonWeb from './FocusInspectionButtonWeb';

const TransparentReportSectionWeb = () => (
  <Stack sx={{ pt: 20, pb: 10, pr: '75px', pl: '90px', backgroundColor: 'white' }}>
    <Stack flexDirection="row" justifyContent="space-between" pb={8}>
      <Stack maxWidth={500}>
        <Typography color="#121212" fontWeight={700} fontSize={48} lineHeight={1.2}>
          Transparent Reports, Just a Scan Away{' '}
        </Typography>
      </Stack>
      <Stack maxWidth={450} mr={2}>
        <Typography color="#121212" fontWeight={600} fontSize={23} lineHeight={1.5}>
          Every FOCUS Certified Inspection report is securely stored online.{' '}
        </Typography>
        <Typography color="#121212" fontWeight={400} fontSize={23} lineHeight={1.5}>
          Anyone can verify it by simply scanning the QR code on the report.{' '}
        </Typography>
      </Stack>
    </Stack>
    <Stack gap={10} flexDirection="row">
      <Stack gap={8} width="38%" justifyContent="center">
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/QrCode.webp"
          alt="Focus Inspection"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px', height: 110, width: 'fit-content' }}
        />
        <Stack mt={2} gap={1}>
          <Typography color="#000000" fontSize="19px" fontWeight={400}>
            📱 QR-enabled reports for instant access
          </Typography>
          <Typography color="#000000" fontSize="19px" fontWeight={400}>
            🔒 Tamper-proof and securely stored
          </Typography>
          <Typography color="#000000" fontSize="19px" fontWeight={400}>
            🔍 Build trust when buying or selling a car
          </Typography>
        </Stack>
        <FocusInspectionButtonWeb
          title="Book  Your Inspection Now"
          subtitle="Inspection team will contact you soon."
          subTitleColor="#121212"
          onClick={() => console.log('Button clicked')}
        />{' '}
      </Stack>
      <Stack width="62%" justifyContent="end">
        <CardMedia
          component="img"
          className=""
          src="assets/images/Inspection/transparentReport.webp"
          alt="Focus Inspection"
          // height={isMobile ? 25 : 40}
          sx={{ objectFit: 'contain', borderRadius: '10px' }}
        />
      </Stack>
    </Stack>
  </Stack>
);

export default TransparentReportSectionWeb;
